"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CloseIcon = ({ className, width = '20', height = '20', onClick, }) => {
    return (react_1.default.createElement("div", { onClick: onClick, role: onClick ? 'button' : undefined },
        react_1.default.createElement(react_1.default.Suspense, { fallback: null },
            react_1.default.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "currentColor", className: className, xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("path", { d: "M4.72461 15.5117L14.7246 5.51172M4.72461 5.51172L14.7246 15.5117", stroke: "#3E4758", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })))));
};
exports.default = CloseIcon;
//# sourceMappingURL=CloseIcon.js.map